export default __webpack_public_path__ + "static/media/fab_logo.1af5a114.png";